
import Vue from 'vue';
import 'vue-demi';
import VueCompositionAPI from '@vue/composition-api';
import { PiniaVuePlugin } from 'pinia';

Vue.use(VueCompositionAPI);
Vue.use(PiniaVuePlugin);
